import AttendanceAdapter from './base';

export default class Audit extends AttendanceAdapter {
  modelNamePlural = 'audits';
}
